/* Slightly ham fisted - we are recreating the @performyard/models.ResourceLog type here in camel case :)))) */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetResourceLogsResponse () {
        return GetResourceLogsResponse;
    },
    get GetSingleResourceLogResponse () {
        return GetSingleResourceLogResponse;
    }
});
const _zod = require("zod");
const _resourcelog = require("./resource-log");
const GetSingleResourceLogResponse = _resourcelog.ResourceLogModel;
const GetResourceLogsResponse = _zod.z.object({
    results: _resourcelog.ResourceLogModel.array(),
    totalCount: _zod.z.number()
});
